import { EuiFlexGroup,EuiText, EuiFlexItem,EuiIcon } from "@elastic/eui";
import { useEffect, useMemo, useState } from "react";
import { InformePeriodo, PeriodosAdapter } from "../../../../../../../infraestructure/persistence/rest/PeriodosAdapter"
import { useNotifications } from "../../../../../../../shared/hooks/Notifications";
import { ServerErrorMessage } from "../../../../../../../shared/utils/error";

export const TiposInforme = (props:any) =>{

    const {periodo, ejercicio}=props;

    const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	const [data, setData] = useState<any>([])
	let result: any;
  
    useEffect(()=>{
        periodo && getInformesPeriodo(periodo,ejercicio);
    },[periodo])

	const getInformesPeriodo = async (periodo: number, ejercicio: number) => {
		try {
			result = await api.ListarInformesPeriodo(periodo,ejercicio);
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
    };

    const getInformes = useMemo(() =>{
        return data.map((i:InformePeriodo)=>{
            return (
                <EuiFlexGroup>
                    <EuiFlexItem grow={false} style={{justifyContent:'center'}}>
                        <EuiIcon type='documents'/>
                    </EuiFlexItem>
                    <EuiFlexItem>
                        <EuiText>{i.tipoInforme}</EuiText>
                    </EuiFlexItem>
                </EuiFlexGroup>
            )
        })
    },[data])
  
    return (
            data.length > 0 ? <EuiFlexItem>{getInformes}</EuiFlexItem> : null
    )
}